import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { isEmpty } from '../../../common/functions';
import { InsectaServiceBase } from '../insecta.base.service';
import { IVariantType } from '../insecta.models';

@Injectable({
  providedIn: 'root'
})
export class VariantTypeAdminService extends InsectaServiceBase {
  public addVariantType(variantType: IVariantType): Observable<string> {
    return this.post<string>(`/admin/varianttypes`, `v1`, {
      name: variantType.name,
      isActive: variantType.isActive,
      username: variantType.actionBy
    });
  }

  public getVariantType(id: string): Observable<IVariantType> {
    return this.get<IVariantType>(`/admin/varianttypes/${id}`, 'v1');
  }

  public getVariantTypes(includeInActive: boolean | null | undefined): Observable<IVariantType[]> {
    if (isEmpty(includeInActive)) includeInActive = false;

    return this.get<IVariantType[]>(`/admin/varianttypes`, 'v1').pipe(
      map((results) => [...results].filter((x: IVariantType) => includeInActive || x.isActive)),
      map((results) =>
        [...results].sort((a: IVariantType, b: IVariantType) =>
          a.isActive == b.isActive ? (a.name > b.name ? 1 : -1) : a.isActive < b.isActive ? 1 : -1
        )
      )
    );
  }

  public getVariantTypesAll(): Observable<IVariantType[]> {
    return this.getVariantTypes(true);
  }

  public updateVariantType(variantType: IVariantType): Observable<any> {
    return this.put<IVariantType>(`/admin/varianttypes/${variantType.id}`, `v1`, {
      id: variantType.id,
      name: variantType.name,
      isActive: variantType.isActive,
      username: variantType.actionBy
    });
  }
}
